export class TableContextKindColumn {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "fill",
            "baseName": "fill",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextKindColumn.attributeTypeMap;
    }
    constructor() {
    }
}
